import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import { Skeleton } from '@/common/ui/skeleton'
import DomainCard from '../DomainCard'
import AttachDomainDialog from '../AttachDomainDialog'
import BuyDomainDialog from '../BuyDomainDialog'

type DomainListProps = {
	domains: string[]
	clientDomain: string
	isLoading: boolean
}

export default function DomainList({
	domains,
	clientDomain,
	isLoading,
}: DomainListProps) {
	if (isLoading) {
		return (
			<div className="space-y-4">
				<div className="flex items-center justify-between">
					<Skeleton className="h-8 w-48" />
					<Skeleton className="h-10 w-32" />
				</div>
				<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
					{[1, 2, 3].map((i) => (
						<Card key={i}>
							<CardHeader>
								<Skeleton className="h-6 w-full" />
								<Skeleton className="h-4 w-3/4" />
							</CardHeader>
							<CardContent>
								<Skeleton className="h-4 w-full" />
							</CardContent>
						</Card>
					))}
				</div>
			</div>
		)
	}

	// Sort domains: main domain first, then others
	const sortedDomains = [...domains].sort((a, b) => {
		if (a === clientDomain) return -1
		if (b === clientDomain) return 1
		return a.localeCompare(b)
	})

	return (
		<div className="space-y-6">
			<div className="flex items-center justify-between">
				<div>
					<h2 className="text-2xl font-bold tracking-tight">จัดการโดเมน</h2>
					<p className="text-sm text-muted-foreground">
						โดเมนหลัก: <span className="font-semibold">{clientDomain}</span>
					</p>
				</div>
				<div className="flex items-center gap-2">
					<BuyDomainDialog />
					<AttachDomainDialog clientDomain={clientDomain} />
				</div>
			</div>

			{domains.length === 0 ? (
				<Card>
					<CardHeader>
						<CardTitle>ไม่พบโดเมน</CardTitle>
					</CardHeader>
					<CardContent>
						<p className="text-sm text-muted-foreground">
							ยังไม่มีโดเมนในระบบ กรุณาเพิ่มโดเมนใหม่
						</p>
					</CardContent>
				</Card>
			) : (
				<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
					{sortedDomains.map((domain) => (
						<DomainCard
							key={domain}
							domain={domain}
							isMain={domain === clientDomain}
						/>
					))}
				</div>
			)}
		</div>
	)
}
